// Helper functions

const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1)

const capitalize = string =>
  string
    .replaceAll('-', ' ')
    .replaceAll('_', ' ')
    .split(' ')
    .map(word => capitalizeFirstLetter(word))
    .join(' ')

const findOption = (options, value) => options.find(option => option.value === value)

// Exports

export const maybeConvertArrayOfStringValuesToSelectOptions = options => {
  if (!(options instanceof Array)) {
    return options
  }

  return options.map(option => {
    if (option instanceof Object) {
      return option
    }

    const label = capitalize(option)

    return { label, value: option }
  })
}

export const matchDefaultValueToSelectOptions = (options, defaultValue) => {
  if (!defaultValue) {
    return defaultValue
  }

  const isMulti = defaultValue instanceof Array

  if (isMulti) {
    return defaultValue.reduce((acc, value) => {
      const option = findOption(options, value)

      return option ? [...acc, option] : acc
    }, [])
  }

  return findOption(options, defaultValue)
}
